import {Component, EventEmitter, Injector, Output} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {FormGroup} from '@angular/forms';
import {EquipmentFormService} from '../../services/equipment-form.service';
import {EquipmentService} from '../../services/equipment.service';
import {EquipmentSelectControlService} from '../../services/equipment-select-control.service';
import {EquipmentSelect} from '../../equipment-select.namespace';
import ViewStatus = EquipmentSelect.ViewStatus;
import {EquipmentInterfaces} from '@namespaces/equipment.namespace';

@Component({
    selector: 'app-equipment-form',
    template: `
        <form [formGroup]="form" (ngSubmit)="save(form)" (reset)="onReset()">

            <h1>Создать модель оборудования</h1>

            <apparatus-form-fields [form]="form"></apparatus-form-fields>

            <br>

            <app-button className="button-green" [pending]="isPending">
                <lib-icon type="save" [isInText]="true"></lib-icon>
                Сохранить
            </app-button>

            <button type="reset" class="button-default" style="margin-left: 10px">Отмена</button>
        </form>
    `
})

export class EquipmentFormComponent extends FrontendFormComponent {
    public form = new FormGroup({});

    constructor(
        injector: Injector,
        public formService: EquipmentFormService,
        public equipmentService: EquipmentService,
        private equipmentSelectControl: EquipmentSelectControlService,
    ) {
        super(injector);
    }

    init() {

    }

    onReset() {
        this.equipmentSelectControl.setViewStatus(ViewStatus.search);
    }

    afterSave() {
        const {id} = this.form.value;
        this.equipmentService.get({
            id: id
        }).toPromise().then((data: EquipmentInterfaces.Model) => {
            this.equipmentSelectControl.setSelectedEquipment(data);
            this.equipmentSelectControl.setSelectedEquipmentId(id);
            this.isPending = false;
            this.equipmentSelectControl.setViewStatus(ViewStatus.preview);
        }, () => {
            this.isPending = false;
            this.equipmentSelectControl.setViewStatus(ViewStatus.search);
        });
    }
}
